import React from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import SharingStatus from "../../../../../helpers/SharingStatus";

const ExaminationFilesSharingStatCell = props => (
  <b>
    {props.tReady ? (
      props.t(SharingStatus.getTranslationByStatus(props.code))
    ) : (
      <FontAwesomeIcon icon={faCircleNotch} spin className="color-black" />
    )}
  </b>
);

export default withTranslation()(ExaminationFilesSharingStatCell);
